import {Component, Input} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ScheduleTypeDto} from "../../../../core/interfaces/core.types";

@Component({
  selector: 'schedule-appointment-whatsapp',
  templateUrl: 'schedule-appointment-whatsapp.component.html',
})
export class ScheduleAppointmentWhatsappComponent extends CoreComponent {

  phone: string | undefined; // Example phone number
  whatsAppUrl: string | undefined;

  constructor(protected router: Router, protected activatedRoute: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {
    const contact = this.activatedRoute.snapshot.queryParams['contact'];
    this.phone = contact;
    this.whatsAppUrl = `https://wa.me/${this.phone}?text=${encodeURIComponent('Hallo, ich würde gerne mit dir chatten.')}`;
    if (contact) {
      this.refreshComponent()
    }
  }

  refreshComponent() {
    this.initialized = true;
  }


  openWhatsApp(): void {
    window.open(this.whatsAppUrl, '_blank');
  }

}
